const ADDITIONAL_CHARGE_BELOW_ONE_METER_SQUARED = 20;

function hulkapps_custom_init(){
	const hook = setInterval(()=>{
		let hulkDiv = document.querySelector('div[id^="hulkapps_custom_options_"]');
		if (hulkDiv && hulkDiv.querySelector('.custom-formula-calculation')){
			clearInterval(hook);
			main(hulkDiv);
		}
		setTimeout(()=>{
			clearInterval(hook);
		},15000);
	}, 100);

	function main(hulkDiv){
		const basePrice = parsePrice(document.querySelector(".price-item.price-item--regular .money").textContent);

		const formulaOption = hulkDiv.querySelector('.custom-formula-calculation');
		const widthInput = formulaOption.querySelectorAll('input.po_changed_formula.hulkapps_option_child')[0];
		const lengthInput = formulaOption.querySelectorAll('input.po_changed_formula.hulkapps_option_child')[1];

		[widthInput,lengthInput].forEach((input)=>{
			input.addEventListener('change',()=>{
				requestAnimationFrame(checkCalculation);
			});
		})

		function checkCalculation(){
			const width = parseFloat(widthInput.value) || 0;
			const length = parseFloat(lengthInput.value) || 0;

			const isUnderOneSquareMeter = (width, height) => {
				if (!(isNaN(width) || isNaN(height) || width === 0 || height === 0)) {
					return (width * height / 10000) < 1;
				}
				return false;
			};

			if (isUnderOneSquareMeter(width, length)) {
				console.log('Is under one square meter');
				const hidden = formulaOption.querySelector('.hulk_formula_hidden_prop');
				console.log(hidden.getAttribute('value'));
				if (hidden.getAttribute('value')){
					const hiddenValue = hidden.getAttribute('value')?.split('|');
					const additionalCharge = hiddenValue.pop();
					hiddenValue.push(`[${ADDITIONAL_CHARGE_BELOW_ONE_METER_SQUARED.toFixed(2)}]`);
					const newValue = hiddenValue.join('|');
					hidden.setAttribute('value',newValue);
					hidden.setAttribute("data-price", additionalCharge)
					
					document.querySelectorAll(".price-item.price-item--regular .money").forEach(price => {
						price.textContent = formatPrice(basePrice + ADDITIONAL_CHARGE_BELOW_ONE_METER_SQUARED);
					});
				}
			}
		}

		function parsePrice(priceString) {
			let num = priceString.replace(/[^0-9.,]/g, '');

			return parseFloat(num);
		}

		function formatPrice(price) {
			return price.toLocaleString(Shopify.locale + '-' + Shopify.country, {
				style: 'currency',
				currency: Shopify.currency.active
			});
		}
	}
}


if (document.readyState == 'interactive'){
	hulkapps_custom_init();
} else {
	document.addEventListener('DOMContentLoaded',hulkapps_custom_init);
}